import { render, staticRenderFns } from "./GeneralProblem.vue?vue&type=template&id=4ad3a922&scoped=true&lang=pug&"
import script from "./GeneralProblem.vue?vue&type=script&lang=ts&"
export * from "./GeneralProblem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad3a922",
  null
  
)

export default component.exports